import { Endpoint } from './base/endpoints';
import { useBaseService } from './base/useBaseService';

export default function useAnnotations(setId: string, itemId: string) {
  const annotationService: any = useBaseService(
    {
      // annotations will be invalidated on the items endpoint as they can only be got from items
      queryKey: ['items', setId],
      endpoints: {
        create: Endpoint.addAnnotation,
        delete: Endpoint.deleteAnnotation,
        order: Endpoint.orderAnnotations,
        update: Endpoint.updateAnnotation,
      },
    },
    setId
  );

  return {
    ...annotationService,
    data: itemId ? annotationService.data.find((i) => i.id === itemId)?.annotations : annotationService.data,
    liveData: () =>
      itemId ? annotationService.liveData().find((i) => i.id === itemId)?.annotations : annotationService.liveData,
  };
}
